import { createFileRoute } from '@tanstack/react-router';

import { queries } from '../common/api/queryKeys/queries';
import { queryClient } from '../lib/queryClient';
import { OfferDetailPage } from '../offer/detail/OfferDetailPage';

export const Route = createFileRoute('/_app/offer/$id')({
    async loader({ params }) {
        void queryClient.ensureQueryData(queries.offers.detail(params.id));
    },
    component: OfferDetailPage,
});
